import React, {useState} from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import PopupFullPage from '../../../components/Popup/PopupFullPage';
import appConfig from '../../../config/appConfig';
import logState from '../../../services/logger/logState';
import styles from './Logs.module.css';

const Logs = () => {
    const [isVisibleLogs, setIsVisibleLogs] = useState(false);
    const [logs, setLogs] = useState(null);

    const onLogsOpen = () => {
        if (appConfig.getIsLogsVisible()) {
            setLogs(logState.getLogState());
            setIsVisibleLogs(true);
        }
    };
    const onLogsClose = () => setIsVisibleLogs(false);

    const clearLogs = () => {
        setLogs(null);
        logState.clearLogState();
        onLogsClose();
    };

    const title = appConfig.getIsAppVersionVisible() ? appConfig.getAppVersion() : 'Logs';

    return (
        <>
            <button className='absolute bottom-0 right-0 bg-romance px-3 py-1 opacity-80' onClick={onLogsOpen}>
                {title}
            </button>
            {isVisibleLogs && (
                <PopupFullPage onClose={onLogsClose} overlayClassName={styles.LogsPopupOverlay}>
                    {isVisibleLogs && (
                        <div className='p-4 text-left text-12'>
                            <div onClick={clearLogs} className={styles.ClearLogsBtn}>
                                Clear logs
                            </div>
                            <CopyToClipboard text={logs?.map(({log}) => log).join('\n')}>
                                <div className={styles.ClearLogsBtn}>Copy logs</div>
                            </CopyToClipboard>{' '}
                            <div onClick={onLogsClose} className={styles.ClearLogsBtn}>
                                Close
                            </div>
                            {logs?.map(({log}, i) => {
                                return (
                                    <div key={i}>
                                        <div className={styles.Log}>{log}</div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </PopupFullPage>
            )}
        </>
    );
};

export default Logs;
